import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { features, testimonials, faqs } from '@/mocks/data';

export default function About() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于芭乐视频',
    description: '芭乐视频是领先的水果视频平台，聚合蜜桃视频、西瓜视频、樱桃视频等热门平台资源，提供免费高清在线观看服务。',
    mainEntity: {
      '@type': 'Organization',
      name: '芭乐视频',
      description: '芭乐视频为您提供类似香蕉视频、西瓜视频免费的高清电影电视剧，涵盖蜜桃视频、樱桃视频等热门水果视频平台资源。',
      url: 'https://bala-video.com/',
    },
  };

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <section className="pt-20 md:pt-24 pb-8 bg-background-100/70">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            关于我们
          </h1>
          <p className="text-sm text-foreground-500 max-w-2xl">
            了解芭乐视频的品牌故事、平台特色以及用户口碑
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-4">
              品牌介绍
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-900">芭乐视频</strong>成立于2024年，是国内领先的水果主题视频资源平台。我们致力于为广大用户提供<strong className="text-foreground-900">完全免费、高清流畅</strong>的在线观影体验。
              </p>
              <p>
                平台聚合了<strong className="text-foreground-900">蜜桃视频、西瓜视频、樱桃视频</strong>等热门水果视频平台的优质资源，涵盖电视剧、电影、动漫、综艺、纪录片、短剧六大品类。无论您是喜欢追剧的剧迷，还是热爱电影的影迷，都能在芭乐视频找到心仪的内容。
              </p>
              <p>
                我们深知用户对于观影体验的高要求，因此平台采用<strong className="text-foreground-900">全球CDN加速技术</strong>，确保视频播放不缓冲、不卡顿。同时，我们坚持<strong className="text-foreground-900">完全免费</strong>的运营理念，无需注册会员，无需付费订阅，真正做到零门槛观影。
              </p>
              <p>
                芭乐视频团队由一群热爱影视内容的年轻人组成，我们每天都在努力为用户发掘更多优质的视频资源，确保<strong className="text-foreground-900">每日更新</strong>最新剧集和电影。未来，我们将持续优化平台体验，为更多用户带来欢乐和感动。
              </p>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20cozy%20entertainment%20streaming%20workspace%20with%20warm%20ambient%20lighting%20creative%20team%20working%20on%20video%20platform%20cinematic%20atmosphere%20orange%20and%20green%20accents%20professional%20yet%20friendly%20vibe&width=800&height=600&seq=about-bala-video&orientation=landscape"
              alt="芭乐视频团队"
              className="w-full h-full object-cover"
              title="芭乐视频 - 团队工作环境"
            />
          </div>
        </div>
      </section>

      <section className="bg-background-100/70 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-8 text-center">
            平台特色
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
              >
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className={`${feat.icon} text-lg md:text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-label text-sm md:text-base text-foreground-900 font-medium mb-1">
                    {feat.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-8 text-center">
          用户口碑
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <span className="text-sm font-label text-foreground-900 font-medium">
                    {t.name}
                  </span>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`text-xs ${j < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {t.content}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-background-100/70 py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-8 text-center">
            常见问题
          </h2>
          <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70"
              >
                <h3 className="font-label text-sm text-foreground-900 font-medium mb-2">
                  {faq.question}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-8 text-center">
          联系我们
        </h2>
        <div className="max-w-lg mx-auto">
          <div className="space-y-4">
            <div className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <h4 className="text-sm font-label text-foreground-900 font-medium">电子邮箱</h4>
                <p className="text-xs text-foreground-500">contact@bala-video.com</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-customer-service-line text-lg"></i>
              </div>
              <div>
                <h4 className="text-sm font-label text-foreground-900 font-medium">客服微信</h4>
                <p className="text-xs text-foreground-500">bala-video-cs</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                <i className="ri-time-line text-lg"></i>
              </div>
              <div>
                <h4 className="text-sm font-label text-foreground-900 font-medium">工作时间</h4>
                <p className="text-xs text-foreground-500">周一至周日 9:00 - 22:00（全年无休）</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
    </main>
  );
}